module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="datepicker-item-info">\n		'+
((__t=( __('datepicker_item_tip') ))==null?'':__t)+
'<br/>\n	';
 if ( item.name ) { 
__p+='\n		'+
((__t=( __('datepicker_item_selected', {name: item.name}) ))==null?'':__t)+
'\n	';
 } 
__p+='\n</div>\n';
}
return __p;
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/mitch/jsapps/modules/reserva/templates/engine/datepicker-item-info.html
 ** module id = 55
 ** module chunks = 0
 **/